module.exports = __webpack_public_path__ + "static/media/One Family Fund.c0938881.png";